import {
  getPage,
  getDetail,
  getClientPage,
  exportExcel,
} from '@/api/stopandrunanalysisresultserv'

export default {
  state: {
    state_StopAndRunAnalysisResult_GetPageResult: null,
    state_StopAndRunAnalysisResult_GetDetailResult: null,
    state_StopAndRunAnalysisResult_GetClientPageResult: null,
    state_StopAndRunAnalysisResult_ExportExcelResult: null,
  },
  mutations: {
    SET_STOPANDRUNANALYSISRESULT_GETPAGE_RESULT: (state, rst) => {
      state.state_StopAndRunAnalysisResult_GetPageResult = rst;
    },
    SET_STOPANDRUNANALYSISRESULT_GETDETAIL_RESULT: (state, rst) => {
      state.state_StopAndRunAnalysisResult_GetDetailResult = rst;
    },
    SET_STOPANDRUNANALYSISRESULT_GETCLIENTPAGE_RESULT: (state, rst) => {
      state.state_StopAndRunAnalysisResult_GetClientPageResult = rst;
    },
    SET_STOPANDRUNANALYSISRESULT_EXPORTEXCEL_RESULT: (state, rst) => {
      state.state_StopAndRunAnalysisResult_ExportExcelResult = rst;
    },
  },
  actions: {
    StopAndRunAnalysisResultServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_STOPANDRUNANALYSISRESULT_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_STOPANDRUNANALYSISRESULT_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    StopAndRunAnalysisResultServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_STOPANDRUNANALYSISRESULT_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_STOPANDRUNANALYSISRESULT_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    StopAndRunAnalysisResultServ_GetClientPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getClientPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_STOPANDRUNANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_STOPANDRUNANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    StopAndRunAnalysisResultServ_ExportExcel({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        exportExcel(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_STOPANDRUNANALYSISRESULT_EXPORTEXCEL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_STOPANDRUNANALYSISRESULT_EXPORTEXCEL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_StopAndRunAnalysisResult_GetPageResult: state => {
      return state.state_StopAndRunAnalysisResult_GetPageResult;
    },
    get_StopAndRunAnalysisResult_GetDetailResult: state => {
      return state.state_StopAndRunAnalysisResult_GetDetailResult;
    },
    get_StopAndRunAnalysisResult_GetClientPageResult: state => {
      return state.state_StopAndRunAnalysisResult_GetClientPageResult;
    },
    get_StopAndRunAnalysisResult_ExportExcelResult: state => {
      return state.state_StopAndRunAnalysisResult_ExportExcelResult;
    },
  }
}